import {
  IonContent,
  IonFooter,
  IonLoading,
  IonPage,
  IonText,
} from '@ionic/react';
import { Button } from '~/components/defaultUIComponents';
import Toolbar from '../components/Toolbar/Toolbar';
import routes from '../constants/routes.json';
import { useTranslate } from '~/i18n/translate';
import {
  useEndEinmalAuftrag,
  usePauseEinmalAuftrag,
  useResumeEinmalAuftrag,
  useRunningEinmalAuftraege,
} from '~/api/EinmalAuftragApi';
import { useEmployeeId } from '~/state/auth';
import { useNavigate, useParams } from 'react-router';

export default function RunEinmalAuftrag() {
  const t = useTranslate();
  const navigate = useNavigate();
  const employeeId = useEmployeeId();
  const { einmalAuftrag: id } = useParams();
  const einmalAuftragId = Number(id);

  const { data: runningEinmalAuftraege, isLoading } =
    useRunningEinmalAuftraege(employeeId);

  const runningEinmalAuftrag = runningEinmalAuftraege?.find(
    (r) => Number(r.einmal_auftrag.id) === einmalAuftragId,
  );

  const { mutate: endEinmalAuftrag, isPending: endPending } =
    useEndEinmalAuftrag({
      onSuccess: () => {
        return navigate(routes.EINMAL_AUFTRAEGE, { replace: true });
      },
    });

  const { mutate: pauseEinmalAuftrag, isPending: pausePending } =
    usePauseEinmalAuftrag();

  const { mutate: resumeEinmalAuftrag, isPending: resumePending } =
    useResumeEinmalAuftrag();

  const isPaused = runningEinmalAuftrag?.status === 'P';

  const handleEnd = () => {
    if (!runningEinmalAuftrag) return;
    endEinmalAuftrag({ runningEinmalAuftragId: Number(runningEinmalAuftrag.id) });
  };

  const handlePauseResume = () => {
    if (!runningEinmalAuftrag) return;
    const runningId = Number(runningEinmalAuftrag.id);
    if (isPaused) {
      resumeEinmalAuftrag({ runningEinmalAuftragId: runningId });
    } else {
      pauseEinmalAuftrag({ runningEinmalAuftragId: runningId });
    }
  };

  const isActionPending = endPending || pausePending || resumePending;

  return (
    <IonPage>
      <Toolbar>{t('runEinmalAuftrag.toolbar')}</Toolbar>
      <IonContent>
        <IonLoading isOpen={isLoading} />
        <div className="flex flex-col gap-3 px-3 pt-5">
          {runningEinmalAuftrag && (
            <>
              <IonText className="text-xl font-semibold text-gray-800">
                {runningEinmalAuftrag.einmal_auftrag.name}
              </IonText>
              <IonText className="text-gray-600">
                {runningEinmalAuftrag.einmal_auftrag.description}
              </IonText>
            </>
          )}
        </div>
      </IonContent>
      <IonFooter className="bg-white w-full flex">
        <Button
          className="w-full"
          onClick={handlePauseResume}
          disabled={isActionPending || !runningEinmalAuftrag}
        >
          {isPaused ? t('runEinmalAuftrag.resume') : t('runEinmalAuftrag.pause')}
        </Button>
        <Button
          className="w-full"
          onClick={handleEnd}
          disabled={isActionPending || !runningEinmalAuftrag}
        >
          {t('runEinmalAuftrag.end')}
        </Button>
      </IonFooter>
    </IonPage>
  );
}
